export type BinaryAnomalyDefinitionId =
  | "temperature-2m-minus-10y-mean-worker@1"
  | "wind-speed-10m-minus-10y-mean-worker@1";

export type BinaryAnomalyDefinition = {
  id: BinaryAnomalyDefinitionId;
  primaryParameter: string;
  referenceParameter: string;
  formulaLabel: string;
  layerLabel: string;
  legendLabel: string;
  unit: string;
  style: {
    id: string;
    min: number;
    max: number;
    step: number;
  };
};

export const TEMPERATURE_ANOMALY_DEFINITION = {
  id: "temperature-2m-minus-10y-mean-worker@1",
  primaryParameter: "t_2m:C",
  referenceParameter: "t_2m_10y_mean:C",
  formulaLabel: "2 m temperature - 10-year mean",
  layerLabel: "Temperature anomaly",
  legendLabel: "2 m temperature anomaly",
  unit: "C",
  style: {
    id: "metx-temperature-anomaly-v2:-15:15:step-0.5:C",
    min: -15,
    max: 15,
    step: 0.5,
  },
} as const satisfies BinaryAnomalyDefinition;

export const WIND_SPEED_ANOMALY_DEFINITION = {
  id: "wind-speed-10m-minus-10y-mean-worker@1",
  primaryParameter: "wind_speed_10m:kmh",
  referenceParameter: "wind_speed_10m_10y_mean:kmh",
  formulaLabel: "10 m wind speed - 10-year mean",
  layerLabel: "Wind speed anomaly",
  legendLabel: "10 m wind speed anomaly",
  unit: "kmh",
  style: {
    id: "metx-wind-speed-anomaly-v1:-15:15:step-0.5:kmh",
    min: -15,
    max: 15,
    step: 0.5,
  },
} as const satisfies BinaryAnomalyDefinition;

export const BINARY_ANOMALY_DEFINITIONS = [TEMPERATURE_ANOMALY_DEFINITION, WIND_SPEED_ANOMALY_DEFINITION] as const;
export const DEFAULT_BINARY_ANOMALY_DEFINITION = TEMPERATURE_ANOMALY_DEFINITION;

export function getBinaryAnomalyDefinitionById(id: string): BinaryAnomalyDefinition | undefined {
  return BINARY_ANOMALY_DEFINITIONS.find((definition) => definition.id === id);
}

export function getBinaryAnomalyDefinitionByPrimaryParameter(
  primaryParameter: string,
): BinaryAnomalyDefinition | undefined {
  return BINARY_ANOMALY_DEFINITIONS.find((definition) => definition.primaryParameter === primaryParameter);
}
